import { SelectedTicket, SelectedSeat } from 'types/SelectedItem';
import { VoucherApplicableTickets } from 'types/CartItem';

export const voucherIsApplicableToSelectedTickets = (
  voucherApplicableTickets: VoucherApplicableTickets,
  selectedTickets: (SelectedTicket | SelectedSeat)[],
) => {
  return selectedTickets.some(
    ticket =>
      voucherApplicableTickets.findIndex(el => el === ticket.ticketId) >= 0,
  );
};
